import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  Home, Calendar, UtensilsCrossed, Cake, RefreshCw, Users,
  Monitor, MessageSquare, Settings, Briefcase, Gift,
  CircleUser as UserCircle, Truck, ClipboardList,
} from 'lucide-react';

type NavItem = {
  to: string;
  label: string;
  icon: React.ComponentType<any>;
  adminOnly?: boolean;
  frotaOnly?: boolean;
};

const NAV: NavItem[] = [
  { to: '/perfil', label: 'Meu Perfil', icon: UserCircle },
  { to: '/', label: 'Dashboard', icon: Home },
  { to: '/reservas', label: 'Reservas', icon: Calendar },
  { to: '/cardapio', label: 'Cardapio', icon: UtensilsCrossed },
  { to: '/aniversariantes', label: 'Aniversariantes', icon: Cake },
  { to: '/troca-proteina', label: 'Troca de Proteinas', icon: RefreshCw },
  { to: '/sorteio', label: 'Sorteio de Brindes', icon: Gift },
  { to: '/diretorio', label: 'Contatos', icon: Users },
  { to: '/equipamentos', label: 'Equipamentos', icon: Monitor },
  { to: '/mural', label: 'Mural', icon: MessageSquare },
  { to: '/rh', label: 'Portal RH', icon: Briefcase },
  { to: '/frota', label: 'Portal de Frota', icon: Truck, frotaOnly: true },
  { to: '/relatorio-brindes', label: 'Relatorio Brindes', icon: ClipboardList, adminOnly: true },
  { to: '/admin', label: 'Painel Admin', icon: Settings, adminOnly: true },
];

function SidebarImpl() {
  const { user } = useAuth();

  const isAdmin = !!user && (
    user.role === 'admin' ||
    user.role === 'moderador' ||
    user.email === 'admin@grupocropfield.com.br' ||
    user.setor === 'RH' ||
    user.role === 'rh' ||
    user.role === 'sorteio'
  );

  const isFrotaOrAdmin = isAdmin || (!!user && user.role === 'frota');

  return (
    <aside className="w-sidebar h-screen fixed left-0 top-0 bg-white dark:bg-gray-900 border-r border-outline-variant dark:border-gray-700 flex flex-col z-50 transition-colors duration-300">
      <div className="px-6 py-8">
        <div className="flex items-center gap-3">
          <img
            src="/gcf_logo_01.png"
            alt="GCF Group"
            className="h-10 w-auto"
          />
        </div>
      </div>

      <nav className="flex-1 overflow-y-auto hide-scrollbar px-3 space-y-0.5">
        {NAV.filter(item => {
          if (item.to === '/admin' || item.adminOnly) return isAdmin;
          if (item.frotaOnly) return isFrotaOrAdmin;
          return true;
        }).map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              isActive
                ? 'sidebar-item-active'
                : 'sidebar-item'
            }
          >
            <item.icon className="w-5 h-5 flex-shrink-0" />
            <span className="text-sm">{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {user && (
        <div className="p-4 border-t border-outline-variant dark:border-gray-700">
          <div className="flex items-center gap-3 px-2">
            <img
              src={user.picture || 'https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg?w=150'}
              alt={user.name || user.nome || 'Usuario'}
              className="w-10 h-10 rounded-full object-cover border-2 border-primary/20"
              referrerPolicy="no-referrer"
            />
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold text-on-surface dark:text-gray-100 truncate">{user.name || user.nome}</p>
              <p className="text-label-md text-secondary dark:text-gray-400 truncate">{user.setor || user.cargo || ''}</p>
            </div>
          </div>
        </div>
      )}
    </aside>
  );
}

const Sidebar = SidebarImpl;
export { Sidebar };
export default Sidebar;
